import { isNull, isUndefined } from 'lodash'
import { accessActions } from './constants/actions';
import { STATUSES } from './constants/statuses';

export const getDelayName = (delay) => {
  switch (delay) {
  case 0:
  case '0':
    return 'No delay'
  default:
    return `${delay} minutes`
  }
}

export const getDelayFilterName = (delay) => {
  if (isNull(delay) || isUndefined(delay)) {
    return 'Delay'
  }
  const delayNumber = Number(delay);
  if (delayNumber === 0) {
    return 'No delay';
  }
  const minutes = delayNumber / 60;
  return `${minutes} minutes`;
}

export const getServicesFilterName = (services) => {
  if (isNull(services) || isUndefined(services) || !services.length) {
    return 'Service'
  }
  return `Service (${services.length})`
}

export const createActions = (access) => {
  const actionsPull = [];
  const submenuStatuses = [];

  // eslint-disable-next-line guard-for-in
  for (const key in access) {
    const isVisible = access[key];
    if (isVisible && accessActions[key]) {
      if (accessActions[key].status) {
        submenuStatuses.push({
          id: accessActions[key].id,
          title: accessActions[key].title,
        })
      } else {
        actionsPull.push(accessActions[key])
      }
    }
  }

  if (submenuStatuses.length) {
    actionsPull.push(
      {
        id: 'change_status',
        title: 'Change status',
        defActionName: 'change_status',
      },
    )
  }
  return {
    items: actionsPull,
    submenuStatuses,
  };
}

/**
 * @function
 * @name statusesCheck
 * @description Сверяем ID статусов
 * @param {array} statuses
 * @returns {boolean}
 */
export const statusesCheck = (statuses) => {
  let check = true;
  statuses.forEach((status) => {
    if (status.id === null) {
      return true;
    }
    const key = status.code.toUpperCase();
    if (!STATUSES[key] || STATUSES[key]?.id !== status.id) {
      check = false;
    }
  })
  return check;
}

/**
 * @function
 * @name getSelectedServices
 * @description Получаем активные options для селекта
 * @param {array} services
 * @param {array} selectedServices
 * @returns {array}
 */
export const getSelectedServices = (services, selectedServices) => {
  if (services.length && selectedServices?.length) {
    return services.filter((service) => !!selectedServices.includes(Number(service.id)))
  }
  return []
}
